import React from "react";
import ECLSearchInputs from "./components/ECLSearchInputs";
import useSelectorId from "../../../utilities/hooks/useSelectorId";
import { translate } from "../../../utilities/Translate";
import ECLTextInput from "../../ECLInputs/ECLTextInput/ECLTextInput";
import ECLThemeImage from "../ECLThemeImage/ECLThemeImage";
import "./ECLSearch.css";

export default function ECLSearch(props) {
   const searchInstance = useSelectorId();

   // Fires when a relation is selected and handles the dropdown changes
   const selectRelation = (event) => {
      // Need to set a constraint to nudge the user when they provide invalid input.  Datalist filters by wildcard search, so if the input text cannot match to any possible key
      // We need to inform the user.  First we'll knock out the happy path, where the user has provided a full string that matches the name of a relation.
      const inputValue = event?.target?.value;
      if (inputValue) {
         const searchableKey = inputValue;
         const selected = props.searchables[searchableKey];
         if (selected) {
            //In case error was triggered before and not cleared
            event.target.setCustomValidity("");
            // clears text input
            event.target.value = "";
            //set searchable to active to true
            let placeholderSearchables = {};
            Object.entries(props.searchables).forEach(([k, v]) => {
               if (k === searchableKey) {
                  placeholderSearchables[k] = {
                     ...v,
                     active: true,
                     open: true,
                  };
               } else {
                  placeholderSearchables[k] = v;
               }
            });
            //Finally set the placeholder searchable object, with the correct values, into state
            props.setSearchables(placeholderSearchables);
         } else {
            if (
               inputValue === "" ||
               Object.keys(props.searchables).some((k) =>
                  k.includes(inputValue.toLocaleLowerCase()),
               )
            ) {
               event.target.setCustomValidity("");
            } else {
               event.target.setCustomValidity(
                  translate("No columns match this string"),
               );
            }
         }
      }
   };

   function removeSearchable(searchable) {
      props.setSearchables((s) => {
         return {
            ...s,
            [searchable.name]: {
               ...s[searchable.name],
               currentMin: s[searchable.name]?.min,
               currentMax: s[searchable.name]?.max,
               selections: s[searchable.name]?.selections?.map((selection) => {
                  return {
                     ...selection,
                     selected: true,
                  };
               }),
               active: false,
               open: false,
            },
         };
      });
   }

   return (
      <>
         {props.label && (
            <label htmlFor={`search-container-${searchInstance}`}>
               {props.label}
            </label>
         )}
         <div
            className="ecl-search-container"
            id={`search-container-${searchInstance}`}
         >
            <ECLThemeImage fontAwesome="magnifying-glass" />
            <div className="search-widget">
               <div className="searchable-input">
                  {Object.entries(props.searchables)
                     .map((v) => v[1])
                     .filter((searchable) => searchable.active)
                     .map((searchable) => {
                        return (
                           <div
                              key={searchable.name}
                              className={
                                 "searchable-input-combo " +
                                 ((searchable.min &&
                                    searchable.max &&
                                    (searchable.min !== searchable.currentMin ||
                                       searchable.max !==
                                          searchable.currentMax)) ||
                                 searchable.selections?.some((s) => !s.selected)
                                    ? "filtered-searchable"
                                    : "")
                              }
                           >
                              <ECLSearchInputs
                                 searchable={searchable}
                                 setSearchableSelections={(selections) => {
                                    props.setSearchables((s) => {
                                       return {
                                          ...s,
                                          [searchable.name]: {
                                             ...s[searchable.name],
                                             selections: selections,
                                          },
                                       };
                                    });
                                 }}
                                 removeSearchable={removeSearchable}
                                 id={searchInstance}
                                 updateState={props.updateState}
                              />
                           </div>
                        );
                     })}
               </div>
               <ECLTextInput
                  id={`compound-input-${searchInstance}`}
                  onChange={selectRelation}
                  list={"searchable-list" + searchInstance}
                  placeholder={translate("Search")}
               />
            </div>
         </div>
         <datalist id={"searchable-list" + searchInstance}>
            {Object.entries(props.searchables)
               .filter(([k, v]) => k && !v.active)
               .map(([searchableKey, v]) => (
                  <option value={v.name} key={searchableKey}></option>
               ))}
         </datalist>
      </>
   );
}
